import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  Tabs,
  Tab
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './CancellationPolicies.css';

// Component
import Flexible from './Flexible';
import Moderate from './Moderate';
import Strict from './Strict';

// Locale
import messages from '../../locale/jsonMessages';
import history from '../../core/history'

class CancellationPolicy extends React.Component {

  static propTypes = {
    policyType: PropTypes.string.isRequired,
    siteName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  handleSelect = (key) => {
    let policy = key === 1 ? 'Flexible' : (key === 2 ? 'Moderate' : 'Strict')
    history.push('/cancellation-policies/' + policy)
  }

  render() {
    const { policyType, siteName, cancellationInfo, localizedPolicies } = this.props;
    return (
      <Grid>
        <Row className={s.landingContainer}>
          <Col lg={12} md={12} sm={12}>
            <h1 className={cx(s.commonTitleText, s.spaceBottom2, s.pageTitle, s.fontWeightBold)}>
              <FormattedMessage {...messages.cancellationPolicies} /></h1>
            <p className={s.spaceBottom6}>
              {cancellationInfo}
            </p>
            <div className={cx(cx(s.cancellationBg, 'cancellationBg', 'tabBarView', 'tabBarViewRTL', 'cancellationPolicyTabBar'))}>
              <Tabs defaultActiveKey={localizedPolicies.id == 1 ? 1 : (localizedPolicies.id === 2 ? 2 : 3)} id="uncontrolled-tab-example" onSelect={(e) => this.handleSelect(e)} >
                <Tab eventKey={1} title={localizedPolicies?.[1]?.policyName}>
                  <Flexible siteName={siteName} policyData={localizedPolicies?.[1]} />
                </Tab>
                <Tab eventKey={2} title={localizedPolicies?.[2]?.policyName}>
                  <Moderate siteName={siteName} policyData={localizedPolicies?.[2]} />
                </Tab>
                <Tab eventKey={3} title={localizedPolicies?.[3]?.policyName}>
                  <Strict siteName={siteName} policyData={localizedPolicies?.[3]} />
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapState = (state) => ({
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {};
export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(CancellationPolicy)));
